import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";
import { Customer } from "@/models/Customer";

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `customer/getField`,
  mutationType: `customer/updateField`
});

const state = {
  customers: []
};

const actions = {
  GetCustomersForDealer(){
    return new Promise(async (resolve, dispatch) => {
      var customers = await HTTP.get("DealerPortal/GetDealerCustomers");
      customers.then((result) =>
      {
        resolve(result);
      }).
      catch((error)=> {
        dispatch(
          "message/setMessage",
          new httpError({
            message: "Error in getting customers for dealer : " + error.message,
            httpStatus: 500
          }),
          { root: true }
        );
      });

    });
  },
  MoveOrdertoNewDealer(customerID, orderIOs){
    return new Promise(async (resolve, dispatch) => {
      var result= await HTTP.post("DealerPortal/MoveOrderstoCustomer" + customerID, orderIOs);
      result.then((res)=>{
        if (res.status == 200) {
          dispatch(
            "setMessage",
            new httpError({
              message: "Orders successfully moved to" + customerID,
              httpStatus: 200
            })
          );
          }
      }).catch((error) =>{
        dispatch(
          "message/setMessage",
          new httpError({
            message: "Error in moving orders to new employee : " + error.message,
            httpStatus: 500
          }),
          { root: true }
        );
      });
    }

    );
  }
};

const mutations = {
  addRow(state) {
    state.rows.push(new Customer());
  },
  clearRows(state) {
    if (typeof state.rows !== "object") state.rows = [];
    state.rows.length = 0;
    state.rows.push(new Customer());
  },
  removeRow(state) {
    state.rows.pop();
  },
  setRows(state, upload) {
    state.rows.length = 0;
    state.rows = upload;
  },
  setSession(state, session) {
    state.session = session;
  },
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
